/**
 * True when an incoming server copy is older than the cached one — a late,
 * out-of-order response that must not regress the cache.
 */
export function isStaleWrite(
  cached: { updatedAt: Date } | null | undefined,
  incoming: { updatedAt: Date },
): boolean {
  return (
    cached !== null &&
    cached !== undefined &&
    incoming.updatedAt.getTime() < cached.updatedAt.getTime()
  );
}
